import { s3ConfigDev, s3ConfigProd } from './s3Config'

// const DEV_URL = "http://localhost:3000/api";
const DEV_URL = 'http://localhost:3000/api'
const PROD_URL = 'https://registration.lesa2023.asb.edu.my/api'
const REDIS_DEV_URL = 'ws://localhost:3000/cable'
const REDIS_PROD_URL = 'wss://registration.lesa2023.asb.edu.my/cable'

const EVENT_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://lesa2023.cloudexpo.my'
    : 'http://localhost:3001'

const API_URL = process.env.NODE_ENV === 'production' ? PROD_URL : DEV_URL
const REDIS_URL =
  process.env.NODE_ENV === 'production' ? REDIS_PROD_URL : REDIS_DEV_URL

const S3_CONFIG =
  process.env.NODE_ENV === 'production' ? s3ConfigProd : s3ConfigDev

// const ZOOM_SDK_KEY = 'YE8gCremTlq05tKkKgFrA'
// const ZOOM_SDK_SECRET = 'JBRK6M8goZUryC7xuYp9nQ0ryxVK3cNa'

const EVENT_START_TIME = {
  year: 2023,
  month: 3,
  day: 15,
  hour: 8,
  minute: 30,
}

const appConfig = {
  API_URL,
  REDIS_URL,
  S3_CONFIG,
  EVENT_URL,
  EVENT_START_TIME,
}

export default appConfig
